import { useCallback, useEffect, useState } from 'react';
import { cehDrill, setItemProg, type CehDrill } from './prodpay-api';
import { CompPanel } from './CompPanel';

const barClass = (p: number) => (p >= 100 ? 'ok' : p > 0 ? 'warn' : 'bad');

// Drill-down цеха: готовность цеха складывается из готовности изделий по контрактам.
export function CehModal({
  cehId,
  onClose,
  onChanged,
}: {
  cehId: string;
  onClose: () => void;
  onChanged: () => void;
}) {
  const [data, setData] = useState<CehDrill | null>(null);
  const [busy, setBusy] = useState(false);

  const load = useCallback(() => cehDrill(cehId).then(setData), [cehId]);
  useEffect(() => {
    load();
  }, [load]);
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  async function bump(itemId: number, delta: number) {
    setBusy(true);
    try {
      await setItemProg(itemId, delta);
      await load();
      onChanged();
    } finally {
      setBusy(false);
    }
  }

  // Мгновенный отклик на клик: показываем оболочку окна, пока грузятся данные цеха.
  if (!data)
    return (
      <div className="ovl" onClick={onClose}>
        <div className="modal" onClick={(e) => e.stopPropagation()}>
          <div className="modal-h">
            <div className="grow">
              <div className="m-cli">Загрузка…</div>
            </div>
            <button className="icon-btn close-x" onClick={onClose}>
              ✕
            </button>
          </div>
          <div className="mbody">
            <p className="muted">Загрузка цеха…</p>
          </div>
        </div>
      </div>
    );

  return (
    <div className="ovl" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-h">
          <div className="grow">
            <div className="m-cli">{data.ceh.name}</div>
            <div className="m-no">{data.ceh.descr}</div>
          </div>
          <button className="icon-btn close-x" onClick={onClose}>
            ✕
          </button>
        </div>
        <div className="mbody">
          <p className="muted small" style={{ marginBottom: 14 }}>
            Готовность цеха складывается из готовности изделий по контрактам. Кнопками ± ставьте
            готовность изделия — среднее пересчитывает загрузку цеха.
          </p>
          {data.deals.length === 0 && (
            <p className="muted">В этом цехе сейчас нет заказов в производстве.</p>
          )}
          {data.deals.map((d) => (
            <div className="glass" key={d.deal_id} style={{ padding: 14, marginBottom: 12 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
                <b>{d.client}</b>
                <span className="mono muted small">{d.no}</span>
                <span className="chip gold" style={{ marginLeft: 'auto' }}>
                  цех: {d.ceh_prog}%
                </span>
              </div>
              {d.items.map((it) => (
                <div key={it.id} style={{ marginBottom: 12 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 5 }}>
                    <b className="small">{it.name}</b>
                    <span className="muted small">×{it.qty}</span>
                    <span className="qty" style={{ marginLeft: 'auto' }}>
                      <button disabled={busy} onClick={() => bump(it.id, -25)}>
                        −
                      </button>
                      <span className="mono" style={{ width: 44, textAlign: 'center' }}>
                        {it.prog}%
                      </span>
                      <button disabled={busy} onClick={() => bump(it.id, 25)}>
                        ＋
                      </button>
                    </span>
                  </div>
                  <div className={'bar ' + barClass(it.prog)}>
                    <span style={{ width: it.prog + '%' }} />
                  </div>
                  <CompPanel itemId={it.id} dealNo={d.no} itemName={it.name} />
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
